export const displayUserInfo = (userName?: string) => userName ?? 'Unknown User';
